// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__25JPc","title":"InfoRow_title__1eYVy"};